import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ButtonWithIcon } from '@els/els-react--button';

function SortingButtons(props) {
  const { onAscending, onDescending, disableAscending, disableDescending } = props;
  return (
    <section className="u-els-margin-left" role="group" aria-label="Sort order">
      <ButtonWithIcon
        sprite="ArrowDown"
        iconOnly
        type="link"
        onClick={onDescending}
        aria-pressed={disableDescending}
        data-e2e="sort-descending-button"
        className={classnames('sort-descending', {
          'sort-descending-active': disableDescending,
        })}>
        Sort descending
      </ButtonWithIcon>
      <ButtonWithIcon
        sprite="ArrowUp"
        iconOnly
        type="link"
        onClick={onAscending}
        aria-pressed={disableAscending}
        data-e2e="sort-ascending-button"
        className={classnames('sort-ascending', {
          'sort-ascending-active': disableAscending,
        })}>
        Sort ascending
      </ButtonWithIcon>
    </section>
  );
}

SortingButtons.propTypes = {
  onAscending: PropTypes.func.isRequired,
  onDescending: PropTypes.func.isRequired,
  disableAscending: PropTypes.bool.isRequired,
  disableDescending: PropTypes.bool.isRequired,
};

export default SortingButtons;
